import { gql } from "@outschool/ui-apollo";

export const LeaderFragment = gql`
  fragment LeaderFragment on Leader {
    uid
    name
    leader_link
    created_at
    photo
    suspended_at
    cityState
    socialOptOut
    details {
      about
      headline
      headlineTranslated
      countryOfResidence
    }
    is_crosslister
    timeZone
    hasAvailabilitySet
    approved
    ownerOfSellerOrg {
      uid
    }
    teacherForSellerOrg {
      uid
      name
    }
    hasBackgroundCheckExpired
    reviewCount
    averageActivityStarRating
    hasListings
  }
`;
